import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';

import Serializer from 'umg-ember-backend/serializers/application';

export default class ProductSerializer extends Serializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    internationalLabel: 'internationalLabelId',
    label: 'labelId',
    ownedByChannel: 'ownedByChannelId',
  };
}
